const contactsState = {
    contacts: undefined,
    requestingContacts: false,
    requestingCreateContact: false,
    requestingModifyContact: false,
    requestingRemoveContact: false
};
export default contactsState;
